import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class Pagination extends Component {

  doPaginationAction(start) {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);

    params.set('Keywords', this.props.words);
    params.set('sort', this.props.sort);
    params.set('start', start);

    let iref_pn = this.props.sort === '1' ? 'pc_ss_score_btn' + (start / 20 + 1) : 'pc_ss_date_btn' + (start / 20 + 1) ;
    params.set('iref', iref_pn);

    history.push({
        search: params.toString(),
    });
    window.scrollTo(0, 0);
  }

  
  render(){
    let paginationList = [];

    if (this.props.paging) {
      
      if(this.props.paging.max > 1){
        //前
        if(this.props.prev){
          let value = this.props.prev['start'];
          paginationList.push(
            <a className="page-link" key='prev' onClick={this.doPaginationAction.bind(this, value)}><span>&lt;</span>前へ</a>
          );
        }
        //各ページへのリンク
        for(var page in this.props.pages){
          if(this.props.pages[page]['page'] === this.props.paging['num']){
            paginationList.push(
              <em　key={page}>{this.props.pages[page]['page']}</em>
            );
          }else{
            let value = this.props.pages[page]['start'];
            paginationList.push(
              <a className="page-link" key={page} onClick={this.doPaginationAction.bind(this, value)}>{this.props.pages[page]['page']}</a>
            );
          } 
        }
        //後ろ
        if(this.props.next){
          let value = this.props.next['start'];
          paginationList.push(
            <a className="page-link" key='next' onClick={this.doPaginationAction.bind(this, value)}>次へ<span>&gt;</span></a>
          );
        }
      }
      
      return(
        <div className="Pagination" id="SeqNav">
            {paginationList}
        </div>
      );
    } else {
      return null;
    }
  }
}

Pagination.propTypes = {
  post: PropTypes.shape({
      prev: PropTypes.array.isRequired,
      pages: PropTypes.array.isRequired,
      paging: PropTypes.array.isRequired,
      next: PropTypes.array.isRequired,
      page: PropTypes.string.isRequired
  })
}

// このコンポーネントで使いたいデータだけをstore(state)から取得する
function mapStateToProps(state){

  const length = state.posts.length;
  const currentState = state.posts[length - 1];

  if (currentState.items.goo) {
    return {
        words: currentState.items.goo.words,
        sort: currentState.items.goo.sort,
        paging: currentState.items.goo.paging,
        pages: currentState.items.goo.pages,
        prev: currentState.items.goo.prev,
        next: currentState.items.goo.next,
    }
  }
}

export default withRouter(connect(mapStateToProps)(Pagination));